import React from 'react'

type Props = {}

export default function NoMatch({}: Props) {
  return <div>NoMatch</div>
}
